(ns manage.product-selector-page.sections.details
  (:require ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/ToggleButton$default" :as ToggleButton]
            ["@mui/material/ToggleButtonGroup$default" :as ToggleButtonGroup]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["react-hook-form" :as rhf]
            ["src/svg/editor/editing/copy.svg$default" :as Copy]
            ["src/svg/inform/info-circle.svg$default" :as InfoIcon]
            [cljs-bean.core :refer [->clj]]
            [common.form :as form]
            [common.uix.hooks :refer [use-copy-with-toaster]]
            [common.widgets.form-field :refer [form-field]]
            [manage.product-selector-page.widgets :as widgets]
            [uix.core :refer [$ defui]]))

(defui id-field []
  (let [{:keys [control]} (form/use-form-context)
        product-selector-id (rhf/useWatch #js {:name "id" :control control})
        copy-to-clipboard (use-copy-with-toaster {:success-message "Copied product selector ID"})]
    ($ form-field
       {:label "ID"}
       ($ Stack
          {:direction "row"
           :alignItems "center"
           :gap 0.5}
          ($ :span product-selector-id)
          ($ IconButton
             {:onClick #(copy-to-clipboard product-selector-id)}
             ($ SvgIcon ($ Copy)))))))

(defui edit []
  (let [{:keys [control mode]} (form/use-form-context)
        product-selector-id (rhf/useWatch #js {:name "id" :control control})]
    ($ Stack {:gap 2}
       (when product-selector-id
         ($ id-field))

       ($ form-field
          {:label "Name"}
          ($ form/form-text-field
             {:name "name"
              :control control
              :field-props {:size "small"
                            :data-testid "Product Selector Name"}}))

       ($ form-field
          {:label "Type"
           :label-action ($ Tooltip
                            {:placement "right"
                             :title "Single applies a set of filters to return up to 10 products,
                                         combined groups multiple selectors to return up to 10 products."}
                            ($ SvgIcon {:sx #js {:color "grey.40"}}
                               ($ InfoIcon)))}
          ($ rhf/Controller
             {:name "type"
              :control control
              :render (fn [^js props]
                        (let [{{:keys [onChange value]} :field} (->clj props)]
                          ($ ToggleButtonGroup
                             {:direction "row"
                              :value value
                              :onChange onChange
                              :exclusive true
                              :disabled (not= mode :create)
                              :size "small"}
                             ($ ToggleButton
                                {:value "single"
                                 :sx #js {:flex 1}}
                                "Single")
                             ($ ToggleButton
                                {:value "combined"
                                 :sx #js {:flex 1}}
                                "Combined"))))})))))

(defui read []
  (let [{:keys [getValues]} (form/use-form-context)
        {:keys [name type]} (->clj (getValues))]
    ($ Stack {:gap 2}
       ($ id-field)
       ($ form-field
          {:label "Name"}
          ($ :span name))
       ($ form-field
          {:label "Type"}
          ($ Typography {:sx #js {:textTransform "capitalize"}}
             type)))))

(defui details []
  (let [{:keys [mode]} (form/use-form-context)]
    ($ widgets/section-card
       {:title "Details"}
       (if (= mode :read)
         ($ read)
         ($ edit)))))
